import { ComponentType, MaintenanceDataItem } from '@/generated/GeneratedApiTypes';

/**
 * postMessage contract for the maintenance-data table appointment bridge.
 *
 * These type strings are the authoritative contract: the WFE side (web-workshop,
 * `MfeMessageHandler.jsx`) must use them verbatim.
 */

// VD → WFE
export const VD_MAINTENANCE_TABLE_CONTEXT_REQUEST = 'VD_MAINTENANCE_TABLE_CONTEXT_REQUEST';
export const VD_SCHEDULE_APPOINTMENT_REQUEST = 'VD_SCHEDULE_APPOINTMENT_REQUEST';
export const VD_EDIT_APPOINTMENT_REQUEST = 'VD_EDIT_APPOINTMENT_REQUEST';
export const VD_CANCEL_APPOINTMENT_REQUEST = 'VD_CANCEL_APPOINTMENT_REQUEST';

// WFE → VD
export const WFE_MAINTENANCE_TABLE_CONTEXT_RESPONSE = 'WFE_MAINTENANCE_TABLE_CONTEXT_RESPONSE';

/** Appointment action keys shared between VD's state machine and the WFE `availableActions` gate. */
export type AppointmentActionKey = 'schedule' | 'editAppointment' | 'cancelAppointment';

export interface ContextRequestItem {
    itemId: string;
    itemType: ComponentType;
    appointmentId?: string;
}

export interface ContextRequestPayload {
    assetId: string;
    items: ContextRequestItem[];
}

export interface ScheduleRequestPayload {
    assetId: string;
    items: { itemId: string; itemType: ComponentType }[];
}

export interface AppointmentIdPayload {
    appointmentId: string;
}

export interface ContextResponsePayload {
    availableActions: AppointmentActionKey[];
    changed: boolean;
}

/**
 * The appointment-item identity WFE uses to correlate a row to an appointment.
 *
 * This mirrors the VD backend's appointment_items join
 * (`MaintenanceDataRepositoryImpl`): maintenance components are keyed by `cid`,
 * custom components by their resource id. Sending the wrong id would make WFE
 * fail to resolve the appointment, so both the context request and the schedule
 * request must use this.
 */
export const appointmentItemIdOf = (item: MaintenanceDataItem): string =>
    item.component_type === 'MAINTENANCE_COMPONENT' ? String(item.cid) : item.resource_id;
